import Skeleton from 'react-loading-skeleton';
import { Text } from '@intellecteu/common-ui';
import { ui } from 'ui/styles';

import 'react-loading-skeleton/dist/skeleton.css';

export const HealthStatusSkeleton = () => {
  return (
    <div>
      <Text weight={Text.weight.bold} size={Text.size.s}>
        Health Status
      </Text>

      <ul className={ui.detailsList}>
        <Skeleton height={25} width={200} />
        <Skeleton height={25} width={200} />
        <Skeleton height={25} width={200} />
      </ul>

      <br />

      <Skeleton height={35} width={200} />
    </div>
  );
};
